export const DownloadOptions = ({ variant = "default" }) => {
	const isLight = variant === "light";

	return (
		<div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
			<a
				href="https://play.google.com/store/apps/details?id=com.devstack.efektivos"
				target="_blank"
				rel="noreferrer"
				className={`
					group inline-flex items-center gap-3 px-6 py-3.5 rounded-xl
					transition-all duration-300 transform hover:scale-[1.02]
					${isLight
						? 'bg-primary text-white hover:bg-primary/90'
						: 'bg-white text-primary hover:bg-white/95 shadow-elevated'
					}
				`}
			>
				<svg className="w-7 h-7" viewBox="0 0 24 24" fill="currentColor">
					<path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
				</svg>
				<div className="text-left">
					<div className={`text-caption ${isLight ? 'text-white/70' : 'text-surface-500'}`}>
						Descargar en
					</div>
					<div className="text-body-md font-semibold -mt-0.5">Google Play</div>
				</div>
				<svg className="w-4 h-4 ml-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
				</svg>
			</a>
		</div>
	);
};
